import { FC, useState } from 'react';
import { cx } from './cx';
import { useLoginAdapter, LoginCloseType } from './login-adapter';
import { SharedSpriteIcon } from './icons';

type pageSource = 'subscription' | 'login';

// -----------------------------------------------------------------------------
interface Props {
  source: pageSource;
  show: boolean;
  handleClose: (loginCloseType?: LoginCloseType) => void;
}

// -----------------------------------------------------------------------------
const VerificationView: FC<Props> = (props) => {
  const { show, handleClose, source } = props;
  const { currentUser, resendVerification, assetBaseUrl } = useLoginAdapter();
  const [showResendAnimation, setShowResendAnimation] =
    useState<boolean>(false);

  const sentGhostClassName = cx({
    active: showResendAnimation,
  });

  // ---------------------------------------------------------------------------
  const handleResend = async () => {
    setShowResendAnimation(false);
    const success = await resendVerification(currentUser.profile.email);
    if (!success) {
      return;
    }

    setShowResendAnimation(true);
  };

  // ---------------------------------------------------------------------------
  if (!show) {
    return null;
  }

  // ---------------------------------------------------------------------------
  return (
    <section className="state-verification">
      <div className="verification-header">
        <button
          className="clean-icon-btn close-window"
          onClick={() => handleClose('skip')}
        >
          <SharedSpriteIcon icon="closeSmall" />
        </button>
      </div>

      <div className="verification">
        <div className="graphic-stuff">
          <img src={`${assetBaseUrl}/static_next/img/login/verify-email.webp`} />
        </div>

        <div className="main-message">
          <h1>Almost ready! Please verify your email</h1>

          <p>
            Please check your email and click the verification link to finish
            creating your account.
          </p>

          <div className="footer">
            <p>
              No email in your inbox or spam folder?
              <span id="sent-ghost" className={sentGhostClassName}>
                sent!
              </span>
              <button onClick={handleResend}>&nbsp;Resend it</button>
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default VerificationView;
